





















































































































import Pagination from "../core/UI/Pagination.vue";
import moment from "moment";
import { InterventionApi } from "../api/InterventionApi";
import { Intervention } from "../models/Intervention";
import BonDePassageModal from "../intervention/BonDePassageModal.vue";
import InterventionModal from "../intervention/InterventionModal.vue";

export default {
    name: "InterventionStatusNotificationsList",
    components: { BonDePassageModal, InterventionModal, Pagination },
    data() {
        return {
            interventions: [],
            InterventionApi: new InterventionApi(),
            currentPage: 1,
            totalPages: 1,
            bonDePassageModal: {
                show: false,
                selectedInterventions: [],
            },
            interventionModal: {
                interventionId: null,
            },
        };
    },
    created() {
        this.refreshInterventions();
    },
    methods: {
        loadPage(page: number) {
            let self = this;
            let params = {
                limit: 10,
                page: page,
                to_notify: true,
                sort: "date_prevue_intervention#desc",
                include: "photos,client.related_contacts",
                datePrevueFrom: moment(0).format("YYYY-MM-DD"),
                datePrevueTo: moment().add(1, "week").format("YYYY-MM-DD"),
            };
            self.InterventionApi.getAll(params).then(function (response) {
                let { data, metadata, paginator } = response;
                self.interventions = data;
                self.currentPage = paginator.current_page;
                self.totalPages = paginator.total_pages;
            });
        },
        refreshInterventions() {
            this.loadPage(this.currentPage);
        },
        toNotifyCssClass(intervention: Intervention) {
            let now = moment();
            if (intervention.latest_notified_etat === intervention.etat) {
                return "success";
            } else if (
                intervention.date_prevue_intervention >=
                now.subtract(1, "week").format("YYYY-MM-DD")
            ) {
                return "danger";
            }
        },
        // Modal edit
        editIntervention(intervention: Intervention) {
            this.interventionModal.interventionId = intervention.id;
        },
        onInterventionModalClose() {
            this.interventionModal.interventionId = null;
            this.refreshInterventions();
        },
        // Modal notification
        sendNotification(intervention: Intervention) {
            this.bonDePassageModal.selectedInterventions = [intervention];
            this.bonDePassageModal.show = true;
        },
        onBonDePassageModalClose() {
            this.bonDePassageModal.show = false;
            this.bonDePassageModal.selectedInterventions = [];
            this.refreshInterventions();
        },
    },
};
